import React from 'react';
import PropTypes from 'prop-types';
import { Heading } from '@web/atoms';
import { Caption, StyledQuestion, Subheading } from './styles';

export const Question = React.forwardRef(
  // @ts-ignore
  (
    {
      children,
      caption,
      prompt,
      as,
      bgColor = 'background.base',
      subheadline,
      isUIVariant,
      typography = 'heading3',
      hideCaptionOnInputFocus = false,
      hideSubheadlineOnMobile = false,
      gap = 3,
      padding = [0, 5, 5, 5],
    },
    ref,
  ) => (
    <StyledQuestion
      ref={ref}
      as={as}
      $bgColor={bgColor}
      isUIVariant={isUIVariant}
      $gap={gap}
      $padding={padding}
    >
      <Heading
        headingLevel="h3"
        headingText={prompt}
        position="center"
        typography={typography}
        backgroundColor={bgColor}
        isUIVariant={isUIVariant}
        verticalPadding={1}
      />
      {subheadline && (
        <Subheading $hideSubheadlineOnMobile={hideSubheadlineOnMobile}>
          {subheadline}
        </Subheading>
      )}
      {children}
      {caption && (
        <Caption $hideCaptionOnInputFocus={hideCaptionOnInputFocus}>
          {caption}
        </Caption>
      )}
    </StyledQuestion>
  ),
);

Question.displayName = 'Question';
Question.propTypes = {
  children: PropTypes.node,
  prompt: PropTypes.string.isRequired,
  caption: PropTypes.string,
  as: PropTypes.string,
  bgColor: PropTypes.string,
  subheadline: PropTypes.string,
  typography: PropTypes.string,
  hideCaptionOnInputFocus: PropTypes.bool,
  hideSubheadlineOnMobile: PropTypes.bool,
  gap: PropTypes.number,
  padding: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.number),
  ]),
};
